export default function WithdrawalsPage() {
  return <div style={{ padding: 30 }}><h1>Withdrawals</h1><p>Coming soon...</p></div>;
}
